import { createAction, props } from "@ngrx/store";
import { ICartLineItemReducer } from "./mini-cart-details-reducer";

export const set_mini_cart_details_action = createAction('SET_MINI_CART_DETAILS', props<ICartLineItemReducer>());
export const remove_item_from_mini_cart_action = createAction('REMOVE_ITEM_FROM_MINI_CART',props<{identifier:string}>())